// @ts-nocheck

import { memoize, size } from 'lodash';

import basketActions from '../actions/basket';
import BetBuilder from '../states/betbuilder';
import { BasketActionTypes } from '../types/actions/basket';
import { MyMatchActionTypes } from '../types/actions/mymatch';
import { BasketModes } from '../types/basket';

export const actionTypesToReactOn = [
  BasketActionTypes.ADD_ITEM,
  BasketActionTypes.ADD_BETBUILDER_ITEM,
  BasketActionTypes.DEL_ITEM,
  BasketActionTypes.GET_SELECTION,
  BasketActionTypes.RECEIVE_BONUSES,
  BasketActionTypes.DEL_BONUS,
  BasketActionTypes.SET_LOADING_OK,
  BasketActionTypes.SWITCH_MODE,
  BasketActionTypes.SYSTEM_ITEM_SELECTION_CHANGE,
  BasketActionTypes.SYSTEM_ITEM_SELECTION_RESET,
  BasketActionTypes.ITEM_BANKER_CHANGE,
  BasketActionTypes.STAKE_CHANGE,
  BasketActionTypes.ITEM_STAKE_CHANGE,
  BasketActionTypes.ITEM_SELECTED_FREEBET_CHANGE,
  BasketActionTypes.SELECTED_FREEBET_CHANGE,
  BasketActionTypes.REFRESH,
  BasketActionTypes.SET_CASHOUT,
  BasketActionTypes.VALIDATE_ITEMS,
  MyMatchActionTypes.MERGE,
  MyMatchActionTypes.SPLIT,
];

const translateModeToBetslipType = (mode) => {
  switch (mode) {
    case BasketModes.SIMPLE:
      return 1;
    case BasketModes.COMBINED:
      return 2;
    case BasketModes.SYSTEM:
      return 3;
    default:
      throw new Error(`Unhandled betslip mode '${mode}'`);
  }
};

const createRule = (rule) => {
  try {
    // eslint-disable-next-line no-new-func
    return new Function('betslip', 'betslipType', 'stake', rule);
  } catch (error) {
    console.error(error);
    return null;
  }
};

const getRuleFunction = (rule) => createRule(rule);
const getMemoizedRuleFunction = memoize(getRuleFunction);

const getEligibleBonuses = (bonuses, items, mode, stake) =>
  Object.keys(bonuses)
    .map((promotionId) => {
      const { rule, deleted, title } = bonuses[promotionId];
      const ruleFunction = getMemoizedRuleFunction(rule);
      try {
        const result = ruleFunction(items, translateModeToBetslipType(mode), stake);
        if (result !== null) {
          return {
            promotionId,
            possibleBonus: result,
            title,
            deleted,
          };
        }
      } catch (error) {
        console.error('error with bonuses: ', promotionId);
      }
      return null;
    })
    .filter((k) => k);

export default (store) => (next) => (action) => {
  if (actionTypesToReactOn.indexOf(action.type) !== -1) {
    const returnValue = next(action);
    const { basket, entities } = store.getState();
    const { bonuses, mode, stake, isCashout } = basket;
    const { matches, bets, outcomes } = entities;

    const enhancedItems = Object.keys(basket.items).map((itemId) => {
      const item = basket.items[itemId];
      const match = matches[item.matchId];
      let bet = bets[item.betId];
      let outcome = outcomes[item.oddId];
      const odd = item.validatedValue || item.value;
      let subOutcomes = undefined;

      if (item.betbuilder) {
        bet = { betTypeId: 2335 }; // special bettypeid betbuilder
        outcome = { odd };
        subOutcomes = BetBuilder.aggregateRelatedBetsAndOutcomes(item.selectionItems, bets, outcomes);
      }

      return {
        item: {
          ...item,
          stake: parseFloat(item.stake),
        },
        match,
        bet,
        outcome: {
          ...outcome,
          odd,
        },
        subOutcomes,
      };
    });

    if (size(bonuses) || isCashout) {
      if (mode !== BasketModes.SIMPLE) {
        const eligibleBonuses = getEligibleBonuses(bonuses, enhancedItems, mode, parseFloat(stake) || 0);
        store.dispatch(basketActions.basketSetBonuses({ eligibleBonuses: isCashout ? [] : eligibleBonuses }));
      } else {
        enhancedItems.forEach((enhancedItem) => {
          const eligibleBonuses = getEligibleBonuses(
            bonuses,
            [enhancedItem],
            mode,
            parseFloat(enhancedItem.item.stake) || 0,
          );
          store.dispatch(
            basketActions.basketSetItemBonuses({
              oddId: enhancedItem.item.oddId,
              eligibleBonuses: isCashout ? [] : eligibleBonuses,
            }),
          );
        });
      }
    }

    return returnValue;
  }
  return next(action);
};
